import * as React from 'react';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { fetchApi } from '../../../services/api';
import LoadingPanel from '../../../components/LoadingPanel';
import VehicleNumberStatus from './AllianceVehicles/VehicleNumberStatus';
import './AllianceVehicles.css';
import PhoneCell from '../../../components/cells/PhoneCell';
import DateCell from '../../../components/cells/DateCell';

type Props = {
  shipmentId: string;
}

type State = {
  loading: boolean;
  vehicles: AllianceVehiclesViewModel[]
}

type GetAllianceVehiclesResponse = {
  ShipmentID: string;
  Vehicles: AllianceVehiclesViewModel[];
}

type AllianceVehiclesViewModel = {
    VehicleNumber: string;
    Status: string;
    VehicleType: string;
    PostingClass: string;
    PayLoad: number;
    Dimensions: string;
    Position: string;
    PositionDateTime: Date;
    CarrierName: string;
    CarrierPhone: string;
    Distance: number;
}

export default class LoadBoardAllianceVehicles extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      vehicles: [],
    }

    this.fetch = this.fetch.bind(this);
  }

  public componentDidMount() {
    this.fetch();
  }

  render() {
    if (this.state.loading) {
        return <LoadingPanel />
    }

    return <Grid data={this.state.vehicles}>
        <GridNoRecords>
            No Sylectus Vehicles Found!
        </GridNoRecords>
        <Column field="VehicleNumber" title="Vehicle Number" cells={{ data: VehicleNumberStatus }} />
        <Column field="VehicleType" title="Vehicle Type" />
        <Column field="PostingClass" title="Posting Class" />
        <Column field="PayLoad" />
        <Column field="Dimensions" title="DIMS (LxWxH)" />
        <Column field="Position" />
        <Column field="PositionDateTime" title="Position Date" filter="date" cells={{ data: DateCell }} />
        <Column field="CarrierName" title="Carrier Name" />
        <Column field="CarrierPhone" title="Carrier Phone" cells={{ data: PhoneCell }} />
        <Column field="Distance" format="{0:n0}" />
    </Grid>;
  }

  private fetch() {
    fetchApi('/api/LoadBoard/AllianceVehicles', { ShipmentID: this.props.shipmentId }, 'POST')
      .then((response: GetAllianceVehiclesResponse) => {
        this.setState({ loading: false, vehicles: response.Vehicles });
      })
  }
}
